export function getHasSelection<T>(value: T[] = []): boolean {
	return !!value.length;
}

export function getInputBiId(biId = ''): string | undefined {
	if (biId) {
		return `${biId}-autocomplete-multiple-input`;
	}
}
